<template>
    <div class="container">
        <div class="innerContain">
            <p>
                为使用搭把手回收的服务，您应当阅读并遵守《用户服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款。除非您已阅读并接受本协议所有条款，否则您无权使用搭把手回收提供的服务。您使用搭把手回收的服务即视为您已阅读并同意本协议的约束。 如果您未满18周岁，或者不具备完全民事行为能力，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。否则搭把手回收对于后续注册、使用网站服务等行为而对您所发生的不利后果不承担责任，并有权在知晓该等情况后解除双方的服务协议。
            </p>
            <h4>一、 协议的范围</h4>
            <p>本协议是您与搭把手回收经营者之间关于用户使用搭把手回收相关服务所订立的协议。 搭把手回收的经营者是指法律认可的经营搭把手回收平台的责任主体，“用户”是指使用搭把手回收相关服务的使用人，在本协议中更多地称为“您”。</p>
            <h4>二、 账号与密码安全</h4>
            <p>1. 您在使用搭把手的服务时需要注册一个账号。</p>
            <p>2. 搭把手回收特别提醒您应妥善保管您的账号和密码，当您使用完毕后，应安全退出，因您保管不善导致遭受盗号或密码失窃，责任由您自行承担。</p>
            <p>3. 搭把手回收建议您使用的密码应至少包含以下四类字符中的三类：大写字母、小写字母、数字，以及键盘上的特殊符号，如果因您设置的密码过于简单导致遭受盗号或密码失窃，责任由您自行承担。搭把手回收对于非因搭把手回收方单方原因所致的任何账号安全、隐私保密等问题均不承担责任和所产生的各方损失。</p>
            <h4>三、 用户个人信息保护</h4>
            <p>1. 保护用户个人信息是搭把手回收的一项基本原则。</p>
            <p>2. 您在注册账号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
            <p>3. 搭把手回收将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
            <p>4. 未经您同意，搭把手回收不会向搭把手以外的任何公司、组织和个人披露您的个人信息，但法律法规需要除外。</p>
            <h4>四、 使用本服务的方式</h4>
            <p>1. 使用方式</p>
            <p class="secondStyle">A. 除非您与搭把手回收另有约定，您同意本服务仅为您个人非商业性质的使用。</p>
            <p class="secondStyle">B. 您应当通过搭把手回收提供货认可的方式使用本服务，您依本协议条款所取得的权利不可转让。</p>
            <p class="secondStyle">C. 您不得使用未经搭把手回收授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响。</p>
            <p>2. 违反以上约定视为您的严重违约，搭把手回收可以终止对您的服务，解除双方间的服务协议和法律关系，将您账户余额视为违约金处理。</p>
            <h4>五、 本服务中的软件</h4>
            <p>1. 您在使用本服务的过程中可能需要下载软件，对于这些软件，搭把手回收给予您一项个人、不可转让及非排他性的许可。您仅可为访问或使用服务的目的而使用这些软件。</p>
            <p>2. 为了改善用户体验、保证服务的安全性及产品功能的一致性，搭把手回收可能会对软件进行更新，您应将使用软件更新致最新版本，否则搭把手回收并不保证其能正常使用。</p>
            <h4>六、 知识产权声明</h4>
            <p>搭把手回收在本服务中所使用的商业标识，其著作权或商标权归搭把手回收所有。</p>

        </div>
    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>
    .container{
        background-color: #F8F8F8;
        min-height: 100vh;
    }
    .nav_title{
        height: 60px;
        width: 100%;
        position: fixed;
        line-height: 60px;
        background-color: white;
        text-align: center;
        color: #030303;
        font-size: 16px;
        font-weight: 600;
    }
    .nav_title .imgBox{
        position: absolute;
        left: 15px;
        top: -2px;
    }
    .innerContain{
        padding: 20px 15px;
    }
    .innerContain p{
        font-size: 14px;
        line-height: 24px;
        text-indent: 2em;
    }
    .secondStyle{
        text-indent: 4em!important;
    }
    .innerContain h4{
        padding: 10px 0;
    }

</style>
